export default (initialState = {}) => {
  return () => {
    return {
      brand_id: null,
      category_id: null,
      cess: 0,
      gst_exempted: false,
      gst_rate: null,
      hsn: null,
      margin_expectation: null,
      name: "",
      sku: "",
      subcategory_id: null,
      unit: null,
      status_cd: null,
      ...initialState,
    };
  };
};
